const palette = {
  black: 'rgb(0, 0, 0)',
  grey: 'rgb(112, 112, 112)',
  lightGrey: 'rgb(186, 186, 186)',
  veryLightGrey: '#FAFAFA',
  white: 'rgb(255, 255, 255)',
  green: 'rgb(0, 166, 100)',
  lightGreen: 'rgba(0, 166, 100, 0.1)',
  red: 'rgb(215, 29, 79)',
};

export const cbdTheme = {
  paddingBase: 1,
  marginBase: 1,
  borderBase: 1,
  fontBase: 1,
  borderRadiusBase: 4.5,
  animationDurationBase: 0,
  boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.17)',
  colors: {
    primary: palette.black,
    primaryInverse: palette.white,
    primaryLight: palette.grey,
    primaryVeryLight: palette.lightGrey,
    secondary: palette.white,
    secondaryInverse: palette.black,
    tertiary: palette.lightGrey,
    tertiaryInverse: palette.white,
    disabled: palette.lightGrey,
    success: palette.green,
    successInverse: palette.green,
    confirmation: palette.lightGreen,
    confirmationInverse: palette.lightGreen,
    error: palette.red,
    errorInverse: palette.red,
  },
  palette,
  font: {
    baseFamily: 'HelveticaLightCn',
    baseSize: '12px',
    headerFamily: 'TradeGothicLTStd-BdCn20',
  },
};



// WEBPACK FOOTER //
// ./src/cbdTheme.js